const
  NAME               = 'socialSharer',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME]
;

const
  NEW_WINDOW_TOP      = 125,
  NEW_WINDOW_WIDTH    = 500,
  NEW_WINDOW_LEFT     = _calcLeftPosition(),
  NEW_WINDOW_HEIGHT   = 350,
  NEW_WINDOW_TOOLBAR  = 0,
  NEW_WINDOW_MENUBAR  = 0,
  NEW_WINDOW_TITLEBAR = 0,
  NEW_WINDOW_STATUS   = 0,
  OPEN_LINK_TYPE      = 'popup',
  OPEN_LINK_OPTS      = `top=${NEW_WINDOW_TOP}, width=${NEW_WINDOW_WIDTH}, left=${NEW_WINDOW_LEFT}, height=${NEW_WINDOW_HEIGHT}, toolbar=${NEW_WINDOW_TOOLBAR}, menubar=${NEW_WINDOW_MENUBAR}, titlebar=${NEW_WINDOW_TITLEBAR}, status=${NEW_WINDOW_STATUS}`,
  FACEBOOK            = 'facebook',
  TWITTER             = 'twitter',
  GOOGLEPLUS          = 'googleplus',
  LINKEDIN            = 'linkedin',
  MAIL                = 'mail',
  WHATSAPP            = 'whatsapp',
  TWITTER_REGEXP      = /(twitter)@(\w*)/
;

class SocialSharer {
  constructor(element$, options={}) {
    var type = element$.data('voc-social-sharer');

    this._url = _checkSite(options.url || document.location);

    if (TWITTER_REGEXP.test(type)) {[type, this._twitterUser] = type.split('@');}

    switch (type) {
      case FACEBOOK:
        element$.on('click', this.onFacebook.bind(this));
        break;
      case TWITTER:
        element$.on('click', this.onTwitter.bind(this));
        break;
      case GOOGLEPLUS:
        element$.on('click', this.onGooglePlus.bind(this));
        break;
      case LINKEDIN:
        element$.on('click', this.onLinkedIn.bind(this));
        break;
      case MAIL:
        element$.on('click', this.onMail.bind(this));
        break;
      case WHATSAPP:
        element$.data('action', 'share/whatsapp/share');
        element$.on('click', this.onWhatsapp.bind(this));
    }
  }

  onFacebook() {
    window.open(`//www.facebook.com/sharer.php?u=${this._url}`, OPEN_LINK_TYPE, OPEN_LINK_OPTS);
  }

  onTwitter() {
    var twitterUser = this._twitterUser ? `&via=${this._twitterUser}` : _checkTwitterUser() ? _checkTwitterUser() : '';
    window.open(`//twitter.com/share?text=${encodeURI(_getTitle())}&url=${this._url}${twitterUser}`, OPEN_LINK_TYPE, OPEN_LINK_OPTS);
  }

  onGooglePlus() {
    window.open(`//plus.google.com/share?url=${this._url}`, OPEN_LINK_TYPE, OPEN_LINK_OPTS);
  }

  onLinkedIn() {
    window.open(`//www.linkedin.com/shareArticle?url=${this._url}`, OPEN_LINK_TYPE, OPEN_LINK_OPTS);
  }

  onMail() {
    window.open(`//www.addthis.com/tellfriend_v2.php?v=300&winname=addthis&pub=ra-537cb4845172d4ab&source=men-300&lng=es&s=email&url=${encodeURIComponent(this._url)}${_hasEdition() ? '&' : '?'}${encodeURIComponent('ns_campaign=rrss&ns_mchannel=boton&ns_fee=0&ns_source=em&ns_linkname=undefined')}&title=${encodeURIComponent(_getTitle())}&ate=AT-ra-537cb4845172d4ab/-/-/58f8b5fff498d9d5/2&uid=58f87b3c13039483&description=${encodeURIComponent($('meta[name="description"]').attr('content'))}&ufbl=1&ct=0&ui_email_to=&ui_email_from=&ui_email_note=&pre=${encodeURIComponent(document.location.origin)}&tt=0&captcha_provider=recaptcha2&pro=0&ats=passthrough=twitter=via=${document.querySelector('meta[name="twitter:site"]') ? encodeURIComponent(document.querySelector('meta[name="twitter:site"]').content.slice(1)) : ''}&text=${encodeURIComponent($('meta[name="title"]').attr('content'))}&imp_url=0&smd=rsi=&gen=0&rsc=&dr=${encodeURIComponent(document.location.origin)}&sta=AT-ra-537cb4845172d4ab/-/-/58f8b5fff498d9d5/1&hideEmailSharingConfirmation=undefined&service=email&media=undefined&email_template=undefined&email_vars=undefined&atc=pubid=ra-537cb4845172d4ab&ui_language=es&data_track_clickback=false&data_track_addressbar=false&ui_click=false&product=undefined&widgetId=undefined&ui_pane=email&rb=false`);
  }

  onWhatsapp() {
    window.open(`whatsapp://send?text=${this._url}`, OPEN_LINK_TYPE, OPEN_LINK_OPTS);
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(options) {
    return this.each(function() {
      new SocialSharer($(this), options);
    });
  }
}

$.fn[NAME]             = SocialSharer._jQueryInterface;
$.fn[NAME].Constructor = SocialSharer;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return SocialSharer._jQueryInterface;
};

export default SocialSharer;

/* Private */

function _calcLeftPosition() {return ((screen.width / 2) - (NEW_WINDOW_WIDTH / 2));}

function _checkSite(url) {
  var editions = Voonto.getInstance().lookup('vocento.site.editions');
  return location.search.indexOf('edtn') === -1 && editions.hasEditions ? `${url}?${editions.queryString}=${editions.current}` : url;
}

function _getTitle() {
  var title = document.querySelector('meta[name="title"]');
  return title ? title.content : document.title;
}

function _checkTwitterUser() {
  var username = document.querySelector('meta[name="twitter:site"]');
  return username && username.content ? `&via=${username.content.slice(1)}` : '';
}

function _hasEdition() {
  return Voonto.getInstance().lookup('vocento.site.editions').hasEditions;
}



// WEBPACK FOOTER //
// ./src/plugins/social-sharer.js